export enum SecurityGroupIds {
  GodEmperor = '10c6725a-bbf9-4809-96a9-1bc247d8d854',
}
